var defaultLanguage = "en";
var version = "7.44.3";
var supportedLanguages = [
	"en",
	"cs",
	"da",
	"de",
	"el",
	"es",
	"eu",
	"fi",
	"fr",
	"ht",
	"hu",
	"id",
	"in",
	"it",
	"ja",
	"ko",
	"ms",
	"nb",
	"nl-NL",
	"ok-PL",
	"ok-SK",
	"pl",
	"pt-BR",
	"ro",
	"ru",
	"sv",
	"th",
	"tr",
	"uk",
	"vi",
	"zh-CN",
	"zh-TW"
];
var config = {
	defaultLanguage: defaultLanguage,
	version: version,
	supportedLanguages: supportedLanguages
};

export { config as default, defaultLanguage, supportedLanguages, version };
//# sourceMappingURL=config.json.js.map
